const actionMessage = 'Please try again later';
const bodyText =
  'We’ll work quickly to resolve this issue, please come back and try again. We apologize for the inconvenience.';

export { actionMessage, bodyText };
